import WebViewResource from '../../../../services/resources/WebViewResource';
import { AppWebViewMessageTypes } from '../../../../services/exports/Constants';
import { FC, ReactElement } from 'react';
import { IAlert } from '../Interfaces';
import { useTranslation } from 'react-i18next';
import { IonAlert } from '@ionic/react';
import useMobileApp from '../../../../hooks/mobile-app/useMobileApp';
import useInitialData from '../../../../hooks/global/useInitialData';

const RequestAppReviewAlert: FC<IAlert> = ({ onClose, isOpen }): ReactElement => {
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Alerts:RequestAppReviewAlert' });
  const { data } = useInitialData();
  const { franchise } = data;
  const { isAndroid } = useMobileApp();

  const onConfirm = (): void => {
    WebViewResource.sendMessage(AppWebViewMessageTypes.RequestAppRating, null);
    onClose();
  };

  return (
    <>
      <IonAlert
        isOpen={isOpen}
        header={t('title')}
        message={t('description', {
          name: franchise?.mobile_app?.name,
          store: isAndroid ? 'Play Store' : 'Apple Store',
        })}
        cssClass="ion-alert"
        buttons={[
          {
            text: t('buttons.not_now'),
            role: 'cancel',
            handler: onClose,
          },
          {
            text: t('buttons.continue'),
            role: 'confirm',
            handler: onConfirm,
          },
        ]}
      ></IonAlert>
    </>
  );
};

export default RequestAppReviewAlert;
